import { LazyImport, LazyModule } from 'owa-bundling';
import type { ActionSource } from 'owa-analytics-types';
import type { MenuItemType } from 'owa-filterable-menu';
import type { DirectionalHint } from '@fluentui/react/lib/ContextualMenu';
import type { MailboxInfo } from 'owa-client-types';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "MoveToFolder"*/ './lazyIndex')
);

const lazyGetMoveToPropertiesForContextMenu = new LazyImport(
    lazyModule,
    m => m.getMoveToPropertiesForContextMenu
);
const lazyGetMoveToContextCallbacks = new LazyImport(lazyModule, m => m.getMoveToContextCallbacks);
const lazyGetCopyToProperties = new LazyImport(lazyModule, m => m.getCopyToProperties);
const lazyGetCopyToContextCallbacks = new LazyImport(lazyModule, m => m.getCopyToContextCallbacks);

export function getMoveToContextCallbacks(
    mailboxInfo: MailboxInfo,
    actionSource: ActionSource,
    tableViewId: string,
    shouldShowBehavior: (item: MenuItemType, mailboxInfo: MailboxInfo) => boolean
) {
    let moveToControl = undefined;
    const getMoveToContextCallbacksFunc = lazyGetMoveToContextCallbacks.tryImportForRender();
    if (getMoveToContextCallbacksFunc) {
        moveToControl = getMoveToContextCallbacksFunc(
            mailboxInfo,
            actionSource,
            tableViewId,
            shouldShowBehavior
        );
    }

    return moveToControl;
}

export function getCopyToContextCallbacks(tableViewId: string, actionSource: ActionSource) {
    let copyToControl = undefined;
    const getCopyToContextCallbacksFunc = lazyGetCopyToContextCallbacks.tryImportForRender();
    if (getCopyToContextCallbacksFunc) {
        copyToControl = getCopyToContextCallbacksFunc(tableViewId, actionSource);
    }
    return copyToControl;
}

export function getMoveToPropertiesForContextMenu(
    tableViewId: string,
    mailboxInfo: MailboxInfo,
    onDismiss: (ev?: any) => void,
    actionSource: ActionSource,
    shouldShowBehavior: (item: MenuItemType, mailboxInfo: MailboxInfo) => boolean,
    directionalHint: DirectionalHint,
    rowKeysToMove?: string[]
) {
    let moveToControl = undefined;
    const getMoveToPropertiesForContextMenuFunc =
        lazyGetMoveToPropertiesForContextMenu.tryImportForRender();
    if (getMoveToPropertiesForContextMenuFunc) {
        moveToControl = getMoveToPropertiesForContextMenuFunc(
            tableViewId,
            mailboxInfo,
            onDismiss,
            actionSource,
            shouldShowBehavior,
            directionalHint,
            rowKeysToMove
        );
    }

    return moveToControl;
}

export function getCopyToProperties(
    tableViewId: string,
    onDismiss: (ev?: any) => void,
    actionSource: ActionSource
) {
    let copyToControl = undefined;
    const getCopyToPropertiesFunc = lazyGetCopyToProperties.tryImportForRender();
    if (getCopyToPropertiesFunc) {
        copyToControl = getCopyToPropertiesFunc(tableViewId, onDismiss, actionSource);
    }

    return copyToControl;
}
